import React, { useState, useEffect, memo } from 'react';
import { Slider } from 'antd';
// import '@style/components/iaOptions.scss';
import '../../../../styles/components/iaOptions.scss';
const IaOption = ({ name, data, onClick, isEditing, canCheckMore }) => {
  const [isQuestionSelected, setQuestionSelected] = useState(data.questioned);
  const [sliderValue, setSliderValue] = useState(
    data.value === null ? 50 : data.value,
  );
  useEffect(() => {
    // console.log(data);
    // setSliderValue(data.value === null ? 50 : data.value);
    // setQuestionSelected(data.questioned);
  }, [data]);
  const onOptionClick = (e) => {
    isEditing && onClick('click');
  };
  const selectQuestion = (e) => {
    e.stopPropagation();
    if (isEditing) {
      onClick('question', !isQuestionSelected);
      setQuestionSelected(!isQuestionSelected);
    }
  };
  const onAfterChange = (e) => {
    setSliderValue(e);
    onClick('slider', e);
  };
  const onChange = (e) => {
    setSliderValue(e);
  };
  return (
    <div className={`ia-option ${data.isSelected ? 'selected' : ''}`}>
      <div className="name" onClick={onOptionClick}>
        {name}
      </div>
      {data.isSelected && !canCheckMore ? (
        <Slider
          onChange={onChange}
          value={sliderValue}
          onAfterChange={onAfterChange}
          tooltipVisible={false}
          disabled={!isEditing}
        />
      ) : null}
      {data.isSelected ? (
        !isQuestionSelected ? (
          <div
            className="icon-question appkiticon icon-help-question-outline"
            onClick={selectQuestion}
          />
        ) : (
          <div
            className="icon-question appkiticon icon-help-question-fill"
            onClick={selectQuestion}
          />
        )
      ) : null}
    </div>
  );
};

export default memo(IaOption);
